// extracted by mini-css-extract-plugin
export default {"wrapper":"SubscriptionPlanDescription_wrapper__mQyIe","sectionsWrapper":"SubscriptionPlanDescription_sectionsWrapper__1PEHr","section":"SubscriptionPlanDescription_section__izolZ"};